import LoadingDots from './LoadingDots.vue'

export { LoadingDots }
export default LoadingDots
